import { render, staticRenderFns } from "./VideoPopup.vue?vue&type=template&id=5d99219f&scoped=true&"
import script from "./VideoPopup.vue?vue&type=script&lang=ts&"
export * from "./VideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPopup.vue?vue&type=style&index=0&id=5d99219f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99219f",
  null
  
)

export default component.exports